<a [routerLink]="linkHelper.go(charTypeId, recordId)" target="_blank">
  <span>{{title ? title : recordId}}</span>
  @if (recordRevisionId > 0) {
    <span>-{{recordRevisionId}}</span>
  }
</a>